import {Component} from '@angular/core';
import {FabContainer, LoadingController, ModalController, NavController, NavParams, Platform} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {ProgressReportPage} from "../progress-report/progress-report";
import {AllProgressReportPage} from "../all-progress-report/all-progress-report";
import {MonthwiseProgressReportPage} from "../monthwise-progress-report/monthwise-progress-report";
import {DefaultProgressPage} from "../default-progress/default-progress";
import {StdwiseStatusProgressPage} from "../stdwise-status-progress/stdwise-status-progress";
import {ArchiveStdWiseReportPage} from "../archive-std-wise-report/archive-std-wise-report";
import {ArchiveSourceWiseReportPage} from "../archive-source-wise-report/archive-source-wise-report";
import {ArchiveDateWiseReportPage} from "../archive-date-wise-report/archive-date-wise-report";
import {ArchiveUserWiseReportPage} from "../archive-user-wise-report/archive-user-wise-report";
import {AllStdProgressReportPage} from "../all-std-progress-report/all-std-progress-report";
import {DailyLogReportPage} from "../daily-log-report/daily-log-report";
import {ArchiveStdReasonsReportPage} from "../archive-std-reasons-report/archive-std-reasons-report";
import {MonthlyLogsReportPage} from "../monthly-logs-report/monthly-logs-report";
import {SocialSharing} from "@ionic-native/social-sharing";
import {Storage} from "@ionic/storage";
import {TotalNoOeEnQReportAllSchoolPage} from "../total-no-oe-en-q-report-all-school/total-no-oe-en-q-report-all-school";
import {AllSchoolAdmisssionsReportPage} from "../all-school-admisssions-report/all-school-admisssions-report";
import {DataProcessModuleLogsPage} from "../data-process-module-logs/data-process-module-logs";
import {NonenquirylogPage} from "../nonenquirylog/nonenquirylog";
import {DailyCallLogsPage} from "../daily-call-logs/daily-call-logs";
import {AddJustdialDataPage} from "../add-justdial-data/add-justdial-data";
import {EnquiryFormPage} from "../enquiry-form/enquiry-form";
import {DatePipe} from "@angular/common";
import {AllSchoolEnquiryReportsPage} from "../all-school-enquiry-reports/all-school-enquiry-reports";
import {PreviousSchoolReportPage} from "../previous-school-report/previous-school-report";
import {MonthwiseJustdialEnqReportPage} from "../monthwise-justdial-enq-report/monthwise-justdial-enq-report";
import {MonthwiseWebsiteEnqReportPage} from "../monthwise-website-enq-report/monthwise-website-enq-report";


@Component({
  selector: 'page-data-progress',
  templateUrl: 'data-progress.html',
})
export class DataProgressPage {

  HomeReport: any;
  GWE_ShareDatawhatsapp_SOD: any;
  GWW_ShareDatawhatsapp_SOD: any;
  GEIS_ShareDatawhatsapp_SOD: any;

  GWE_ShareDatawhatsapp: any;
  GWW_ShareDatawhatsapp: any;
  GEIS_ShareDatawhatsapp: any;

  FUserId: any;
  useName: any;

  Date: any;
  DisplayDate = "";
  monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  shownGroup: any;

  constructor(public navCtrl: NavController,
              public loadingCtrl: LoadingController,
              public platform: Platform,
              public socialSharing: SocialSharing,
              public storage: Storage,
              public modalCtrl: ModalController,
              public service: ServiceProvider,
              public datepipe: DatePipe,
              public navParams: NavParams) {

    this.platform.ready().then(() => {

      this.useName = this.service.UserName;

      this.Date = new Date();
      this.DisplayDate = this.Date.getDate() + "-" + this.monthNames[this.Date.getMonth()] + "-" + this.Date.getFullYear() + " | " + this.Date.getHours() + ":" + this.Date.getMinutes();
      this.Date = this.Date.toISOString();


      this.loadvalues();

    });

    Promise.all([this.storage.get('LoginData'), this.storage.get('AllotedMobileNumber')]).then(values => {
      this.FUserId = values[0]['FUserId'];
      console.log(this.FUserId);

    });


  }

  loadvalues() {

    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      duration: 10000
    });
    loader.present();


    this.HomeReport = [];

    this.service.httpcall('app_web_service/get_home_tabs?').subscribe(data => {

      this.HomeReport = data;
      console.log('HomeReport', this.HomeReport);
      loader.dismiss();

      console.log("this.Date->", this.Date);

      var currentdate = this.datepipe.transform(this.Date, 'dd-MMM-yyyy hh:mm');

      console.log("currentdate->", currentdate);

      var GWE = "*" + currentdate + "* *| EOD*";
      GWE += "\n*GWE Progress Report by " + this.useName + "* \n___________________________\n\n" +

        "Today Enqs/Apmts : " + this.HomeReport['TotalProgressAppoints_GWE'] + this.HomeReport['TotalTodaysAppoints_GWE'] + "\n" +
        "Last 7 Days Enqs/Apmts : " + this.HomeReport['Last7DaysPostedAppoints_GWE'] + this.HomeReport['Last7daysAppoints_GWE'] + "\n" +
        "Today Data_Progress/Data_Added : " + this.HomeReport['TodyasDataAddedProgress_GWE'] + this.HomeReport['TodyasDataAddedGWE'] + "\n" +
        "Last 7 Days Data_Progress/Data_Added : " + this.HomeReport['Last7DaysDataAddedProgress_GWE'] + this.HomeReport['Last7DaysDataAdded_GWE'] + "\n" +

        "Total Pending PreData : " + this.HomeReport['PendingPreData_GWE'] + "\n" +
        "Today Data/PreData : " + this.HomeReport['TodaysPreDtToData_GWE'] + "/" + this.HomeReport['TodaysPreData_GWE'] + "\n" +
        "Last 7 Days Data/PreData : " + this.HomeReport['Last7PreDtToData_GWE'] + "/" + this.HomeReport['Last7PreData_GWE'] + "\n" +


        "Pending Past Appointments : " + this.HomeReport['PendingPastAppointment_GWE'] + "\n" +

        "Today Data in Default : " + this.HomeReport['TodaysDataInDefault_GWE'] + "\n" +
        "Last 7 Days Data in Default : " + this.HomeReport['Last7DayDataInDefault_GWE'] + "\n" +
        "Today Total Calls Pending : " + this.HomeReport['TodayPending_GWE'] + this.HomeReport['TodayCalls_GWE'] + "\n" +
        "Total Pending Processes : " + this.HomeReport['TodayPendingProcess_GWE'] + "\n" +

        "Total Data in Default : " + this.HomeReport['DataInDefault_GWE'] + "\n" +

        "Total Apt in Default : " + this.HomeReport['AptInDefault_GWE'] + "\n" +
        "Total Enqs in Deafult : " + this.HomeReport['EnqInDefaultGWE'] + "\n" +
        "Total Feedback in Default : " + this.HomeReport['FBInDefaultGWE'] + "\n" +

        "Today Admissions : " + this.HomeReport['TotalAdmToday_GWE'] + "\n" +

        "Last 7 Days New Admissions/Enqs : " + this.HomeReport['Last7DAdm_GWE'] + "/" + this.HomeReport['Last7DEnq_GWE'] + "\n" +
        "Last 30 Days New Admissions/Enqs : " + this.HomeReport['Last30DAdm_GWE'] + "/" + this.HomeReport['Last30DEnq_GWE'] + "\n" +
        "Last 90 Days New Admissions/Enqs : " + this.HomeReport['Last90DAdm_GWE'] + "/" + this.HomeReport['Last90DEnq_GWE'] + "\n" +
        "Total New Admissions/Enqs : " + this.HomeReport['TotalAdm_GWE'] + "/" + this.HomeReport['TotalEnq_GWE'] + "\n" +

        "Last 7 Days Enqs/Data : " + this.HomeReport['Last7SchEnq_GWE'] + "/" + this.HomeReport['Last7DEnqData_GWE'] + "\n" +
        "Last 30 Days Enqs/Data : " + this.HomeReport['Last30SchEnq_GWE'] + "/" + this.HomeReport['Last30DEnqData_GWE'] + "\n" +
        "Last 90 Days Enqs/Data : " + this.HomeReport['Last90SchEnq_GWE'] + "/" + this.HomeReport['Last90DEnqData_GWE'] + "\n" +
        "Total Enqs/Data : " + this.HomeReport['TotalSchEnq_GWE'] + "/" + this.HomeReport['TotalEnqData_GWE'] + "\n" +

        "Today Data Archived : " + this.HomeReport['ArchivedTodayGWE'] + "\n" +
        "Last 7 Days Data Archived : " + this.HomeReport['Last7DaysDataArchivedGWE'] + "\n" +

        "Last 7 Days Existing Admissions : " + this.HomeReport['Last7DExistingAdmData_GWE'] + "/" + this.HomeReport['Last7DLastYearAdmData_GWE'] + "\n" +
        "Last 30 Days New Admissions : " + this.HomeReport['Last30DExistingAdmData_GWE'] + "/" + this.HomeReport['Last30DLastYearAdmData_GWE'] + "\n" +
        "Last 90 Days New Admissions : " + this.HomeReport['Last90DExistingAdmData_GWE'] + "/" + this.HomeReport['Last90DLastYearAdmData_GWE'] + "\n" +
        "Total New Admissions : " + this.HomeReport['TotalExistingAdmData_GWE'] + "/" + this.HomeReport['TotalLastYearAdmData_GWE'];

      this.GWE_ShareDatawhatsapp = GWE;
      console.log("Dataaa___:", this.GWE_ShareDatawhatsapp);

      var GWE_SOD = "*" + currentdate + "* *| SOD*";
      GWE_SOD += "\n*GWE Progress Report by " + this.useName + "* \n___________________________\n\n" +

        "Today Enqs/Apmts : " + this.HomeReport['TotalProgressAppoints_GWE'] + this.HomeReport['TotalTodaysAppoints_GWE'] + "\n" +
        "Last 7 Days Enqs/Apmts : " + this.HomeReport['Last7DaysPostedAppoints_GWE'] + this.HomeReport['Last7daysAppoints_GWE'] + "\n" +
        "Today Data_Progress/Data_Added : " + this.HomeReport['TodyasDataAddedProgress_GWE'] + this.HomeReport['TodyasDataAddedGWE'] + "\n" +
        "Last 7 Days Data_Progress/Data_Added : " + this.HomeReport['Last7DaysDataAddedProgress_GWE'] + this.HomeReport['Last7DaysDataAdded_GWE'] + "\n" +

        "Total Pending PreData : " + this.HomeReport['PendingPreData_GWE'] + "\n" +
        "Today Data/PreData : " + this.HomeReport['TodaysPreDtToData_GWE'] + "/" + this.HomeReport['TodaysPreData_GWE'] + "\n" +
        "Last 7 Days Data/PreData : " + this.HomeReport['Last7PreDtToData_GWE'] + "/" + this.HomeReport['Last7PreData_GWE'] + "\n" +

        "Pending Past Appointments : " + this.HomeReport['PendingPastAppointment_GWE'] + "\n" +

        "Today Data in Default : " + this.HomeReport['TodaysDataInDefault_GWE'] + "\n" +
        "Last 7 Days Data in Default : " + this.HomeReport['Last7DayDataInDefault_GWE'] + "\n" +
        "Today Total Calls Pending : " + this.HomeReport['TodayPending_GWE'] + this.HomeReport['TodayCalls_GWE'] + "\n" +
        "Total Pending Processes : " + this.HomeReport['TodayPendingProcess_GWE'] + "\n" +

        "Total Data in Default : " + this.HomeReport['DataInDefault_GWE'] + "\n" +

        "Total Apt in Default : " + this.HomeReport['AptInDefault_GWE'] + "\n" +
        "Total Enqs in Deafult : " + this.HomeReport['EnqInDefaultGWE'] + "\n" +
        "Total Feedback in Default : " + this.HomeReport['FBInDefaultGWE'] + "\n" +

        "Today Admissions : " + this.HomeReport['TotalAdmToday_GWE'] + "\n" +

        "Last 7 Days New Admissions/Enqs : " + this.HomeReport['Last7DAdm_GWE'] + "/" + this.HomeReport['Last7DEnq_GWE'] + "\n" +
        "Last 30 Days New Admissions/Enqs : " + this.HomeReport['Last30DAdm_GWE'] + "/" + this.HomeReport['Last30DEnq_GWE'] + "\n" +
        "Last 90 Days New Admissions/Enqs : " + this.HomeReport['Last90DAdm_GWE'] + "/" + this.HomeReport['Last90DEnq_GWE'] + "\n" +
        "Total New Admissions/Enqs : " + this.HomeReport['TotalAdm_GWE'] + "/" + this.HomeReport['TotalEnq_GWE'] + "\n" +

        "Last 7 Days Enqs/Data : " + this.HomeReport['Last7SchEnq_GWE'] + "/" + this.HomeReport['Last7DEnqData_GWE'] + "\n" +
        "Last 30 Days Enqs/Data : " + this.HomeReport['Last30SchEnq_GWE'] + "/" + this.HomeReport['Last30DEnqData_GWE'] + "\n" +
        "Last 90 Days Enqs/Data : " + this.HomeReport['Last90SchEnq_GWE'] + "/" + this.HomeReport['Last90DEnqData_GWE'] + "\n" +
        "Total Enqs/Data : " + this.HomeReport['TotalSchEnq_GWE'] + "/" + this.HomeReport['TotalEnqData_GWE'] + "\n" +

        "Today Data Archived : " + this.HomeReport['ArchivedTodayGWE'] + "\n" +
        "Last 7 Days Data Archived : " + this.HomeReport['Last7DaysDataArchivedGWE'] + "\n" +

        "Last 7 Days Existing Admissions : " + this.HomeReport['Last7DExistingAdmData_GWE'] + "/" + this.HomeReport['Last7DLastYearAdmData_GWE'] + "\n" +
        "Last 30 Days New Admissions : " + this.HomeReport['Last30DExistingAdmData_GWE'] + "/" + this.HomeReport['Last30DLastYearAdmData_GWE'] + "\n" +
        "Last 90 Days New Admissions : " + this.HomeReport['Last90DExistingAdmData_GWE'] + "/" + this.HomeReport['Last90DLastYearAdmData_GWE'] + "\n" +
        "Total New Admissions : " + this.HomeReport['TotalExistingAdmData_GWE'] + "/" + this.HomeReport['TotalLastYearAdmData_GWE'];

      this.GWE_ShareDatawhatsapp_SOD = GWE_SOD;
      console.log("Dataaa___:", this.GWE_ShareDatawhatsapp_SOD);


      var GWW = "*" + currentdate + "* *| EOD*";
      GWW += "\n*GWW Progress Report by " + this.useName + "* \n___________________________\n\n" +

        "Today Enqs/Apmts : " + this.HomeReport['TotalProgressAppoints_GWW'] + this.HomeReport['TotalTodaysAppoints_GWW'] + "\n" +
        "Last 7 Days Enqs/Apmts : " + this.HomeReport['Last7DaysPostedAppoints_GWW'] + this.HomeReport['Last7daysAppoints_GWW'] + "\n" +
        "Today Data_Progress/Data_Added : " + this.HomeReport['TodyasDataAddedProgress_GWW'] + this.HomeReport['TodyasDataAddedGWW'] + "\n" +
        "Last 7 Days Data_Progress/Data_Added : " + this.HomeReport['Last7DaysDataAddedProgress_GWW'] + this.HomeReport['Last7DaysDataAdded_GWW'] + "\n" +

        "Total Pending PreData : " + this.HomeReport['PendingPreData_GWW'] + "\n" +
        "Today Data/PreData : " + this.HomeReport['TodaysPreDtToData_GWW'] + "/" + this.HomeReport['TodaysPreData_GWW'] + "\n" +
        "Last 7 Days Data/PreData : " + this.HomeReport['Last7PreDtToData_GWW'] + "/" + this.HomeReport['Last7PreData_GWW'] + "\n" +
        "Pending Past Appointments : " + this.HomeReport['PendingPastAppointment_GWW'] + "\n" +

        "Today Data in Default : " + this.HomeReport['TodaysDataInDefault_GWW'] + "\n" +
        "Last 7 Days Data in Default : " + this.HomeReport['Last7DayDataInDefault_GWW'] + "\n" +
        "Today Total Calls Pending : " + this.HomeReport['TodayPending_GWW'] + this.HomeReport['TodayCalls_GWW'] + "\n" +
        "Total Pending Processes : " + this.HomeReport['TodayPendingProcess_GWW'] + "\n" +

        "Total Data in Default : " + this.HomeReport['DataInDefault_GWW'] + "\n" +

        "Total Apt in Default : " + this.HomeReport['AptInDefault_GWW'] + "\n" +
        "Total Enqs in Deafult : " + this.HomeReport['EnqInDefaultGWW'] + "\n" +
        "Total Feedback in Default : " + this.HomeReport['FBInDefaultGWW'] + "\n" +

        "Today Admissions : " + this.HomeReport['TotalAdmToday_GWW'] + "\n" +

        "Last 7 Days New Admissions/Enqs : " + this.HomeReport['Last7DAdm_GWW'] + "/" + this.HomeReport['Last7DEnq_GWW'] + "\n" +
        "Last 30 Days New Admissions/Enqs : " + this.HomeReport['Last30DAdm_GWW'] + "/" + this.HomeReport['Last30DEnq_GWW'] + "\n" +
        "Last 90 Days New Admissions/Enqs : " + this.HomeReport['Last90DAdm_GWW'] + "/" + this.HomeReport['Last90DEnq_GWW'] + "\n" +
        "Total New Admissions/Enqs : " + this.HomeReport['TotalAdm_GWW'] + "/" + this.HomeReport['TotalEnq_GWW'] + "\n" +

        "Last 7 Days Enqs/Data : " + this.HomeReport['Last7SchEnq_GWW'] + "/" + this.HomeReport['Last7DEnqData_GWW'] + "\n" +
        "Last 30 Days Enqs/Data : " + this.HomeReport['Last30SchEnq_GWW'] + "/" + this.HomeReport['Last30DEnqData_GWW'] + "\n" +
        "Last 90 Days Enqs/Data : " + this.HomeReport['Last90SchEnq_GWW'] + "/" + this.HomeReport['Last90DEnqData_GWW'] + "\n" +
        "Total Enqs/Data : " + this.HomeReport['TotalSchEnq_GWW'] + "/" + this.HomeReport['TotalEnqData_GWW'] + "\n" +

        "Today Data Archived : " + this.HomeReport['ArchivedTodayGWW'] + "\n" +
        "Last 7 Days Data Archived : " + this.HomeReport['Last7DaysDataArchivedGWW'] + "\n" +

        "Last 7 Days Existing Admissions : " + this.HomeReport['Last7DExistingAdmData_GWW'] + "/" + this.HomeReport['Last7DLastYearAdmData_GWW'] + "\n" +
        "Last 30 Days New Admissions : " + this.HomeReport['Last30DExistingAdmData_GWW'] + "/" + this.HomeReport['Last30DLastYearAdmData_GWW'] + "\n" +
        "Last 90 Days New Admissions : " + this.HomeReport['Last90DExistingAdmData_GWW'] + "/" + this.HomeReport['Last90DLastYearAdmData_GWW'] + "\n" +
        "Total New Admissions : " + this.HomeReport['TotalExistingAdmData_GWW'] + "/" + this.HomeReport['TotalLastYearAdmData_GWW'];

      this.GWW_ShareDatawhatsapp = GWW;
      console.log("GWW_ShareDatawhatsapp:", this.GWW_ShareDatawhatsapp);

      var GWW_SOD = "*" + currentdate + "* *| SOD*";
      GWW_SOD += "\n*GWW Progress Report by " + this.useName + "* \n___________________________\n\n" +

        "Today Enqs/Apmts : " + this.HomeReport['TotalProgressAppoints_GWW'] + this.HomeReport['TotalTodaysAppoints_GWW'] + "\n" +
        "Last 7 Days Enqs/Apmts : " + this.HomeReport['Last7DaysPostedAppoints_GWW'] + this.HomeReport['Last7daysAppoints_GWW'] + "\n" +
        "Today Data_Progress/Data_Added : " + this.HomeReport['TodyasDataAddedProgress_GWW'] + this.HomeReport['TodyasDataAddedGWW'] + "\n" +
        "Last 7 Days Data_Progress/Data_Added : " + this.HomeReport['Last7DaysDataAddedProgress_GWW'] + this.HomeReport['Last7DaysDataAdded_GWW'] + "\n" +

        "Total Pending PreData : " + this.HomeReport['PendingPreData_GWW'] + "\n" +
        "Today Data/PreData : " + this.HomeReport['TodaysPreDtToData_GWW'] + "/" + this.HomeReport['TodaysPreData_GWW'] + "\n" +
        "Last 7 Days Data/PreData : " + this.HomeReport['Last7PreDtToData_GWW'] + "/" + this.HomeReport['Last7PreData_GWW'] + "\n" +
        "Pending Past Appointments : " + this.HomeReport['PendingPastAppointment_GWW'] + "\n" +

        "Today Data in Default : " + this.HomeReport['TodaysDataInDefault_GWW'] + "\n" +
        "Last 7 Days Data in Default : " + this.HomeReport['Last7DayDataInDefault_GWW'] + "\n" +
        "Today Total Calls Pending : " + this.HomeReport['TodayPending_GWW'] + this.HomeReport['TodayCalls_GWW'] + "\n" +
        "Total Pending Processes : " + this.HomeReport['TodayPendingProcess_GWW'] + "\n" +

        "Total Data in Default : " + this.HomeReport['DataInDefault_GWW'] + "\n" +

        "Total Apt in Default : " + this.HomeReport['AptInDefault_GWW'] + "\n" +
        "Total Enqs in Deafult : " + this.HomeReport['EnqInDefaultGWW'] + "\n" +
        "Total Feedback in Default : " + this.HomeReport['FBInDefaultGWW'] + "\n" +

        "Today New Admissions : " + this.HomeReport['TotalAdmToday_GWW'] + "\n" +
        "Last 7 Days New Admissions/Enqs : " + this.HomeReport['Last7DAdm_GWW'] + "/" + this.HomeReport['Last7DEnq_GWW'] + "\n" +
        "Last 30 Days New Admissions/Enqs : " + this.HomeReport['Last30DAdm_GWW'] + "/" + this.HomeReport['Last30DEnq_GWW'] + "\n" +
        "Last 90 Days New Admissions/Enqs : " + this.HomeReport['Last90DAdm_GWW'] + "/" + this.HomeReport['Last90DEnq_GWW'] + "\n" +
        "Total New Admissions/Enqs : " + this.HomeReport['TotalAdm_GWW'] + "/" + this.HomeReport['TotalEnq_GWW'] + "\n" +

        "Last 7 Days Enqs/Data : " + this.HomeReport['Last7SchEnq_GWW'] + "/" + this.HomeReport['Last7DEnqData_GWW'] + "\n" +
        "Last 30 Days Enqs/Data : " + this.HomeReport['Last30SchEnq_GWW'] + "/" + this.HomeReport['Last30DEnqData_GWW'] + "\n" +
        "Last 90 Days Enqs/Data : " + this.HomeReport['Last90SchEnq_GWW'] + "/" + this.HomeReport['Last90DEnqData_GWW'] + "\n" +
        "Total Enqs/Data : " + this.HomeReport['TotalSchEnq_GWW'] + "/" + this.HomeReport['TotalEnqData_GWW'] + "\n" +

        "Today Data Archived : " + this.HomeReport['ArchivedTodayGWW'] + "\n" +
        "Last 7 Days Data Archived : " + this.HomeReport['Last7DaysDataArchivedGWW'] + "\n" +

        "Last 7 Days Existing Admissions : " + this.HomeReport['Last7DExistingAdmData_GWW'] + "/" + this.HomeReport['Last7DLastYearAdmData_GWW'] + "\n" +
        "Last 30 Days New Admissions : " + this.HomeReport['Last30DExistingAdmData_GWW'] + "/" + this.HomeReport['Last30DLastYearAdmData_GWW'] + "\n" +
        "Last 90 Days New Admissions : " + this.HomeReport['Last90DExistingAdmData_GWW'] + "/" + this.HomeReport['Last90DLastYearAdmData_GWW'] + "\n" +
        "Total New Admissions : " + this.HomeReport['TotalExistingAdmData_GWW'] + "/" + this.HomeReport['TotalLastYearAdmData_GWW'];

      this.GWW_ShareDatawhatsapp_SOD = GWW_SOD;
      console.log("GWW_ShareDatawhatsapp_SOD:", this.GWW_ShareDatawhatsapp_SOD);


      var GEIS = "*" + currentdate + "* *| EOD*";
      GEIS += "\n*GEIS Progress Report by " + this.useName + "* \n___________________________\n\n" +

        "Today Enqs/Apmts : " + this.HomeReport['TotalProgressAppoints_GEIS'] + this.HomeReport['TotalTodaysAppoints_GEIS'] + "\n" +
        "Last 7 Days Enqs/Apmts : " + this.HomeReport['Last7DaysPostedAppoints_GEIS'] + this.HomeReport['Last7daysAppoints_GEIS'] + "\n" +
        "Today Data_Progress/Data_Added: " + this.HomeReport['TodyasDataAddedProgress_GEIS'] + this.HomeReport['TodyasDataAddedGEIS'] + "\n" +
        "Last 7 Days Data_Progress/Data_Added : " + this.HomeReport['Last7DaysDataAddedProgress_GEIS'] + this.HomeReport['Last7DaysDataAdded_GEIS'] + "\n" +

        "Total Pending PreData : " + this.HomeReport['PendingPreData_GEIS'] + "\n" +
        "Today Data/PreData : " + this.HomeReport['TodaysPreDtToData_GEIS'] + "/" + this.HomeReport['TodaysPreData_GEIS'] + "\n" +
        "Last 7 Days Data/PreData : " + this.HomeReport['Last7PreDtToData_GEIS'] + "/" + this.HomeReport['Last7PreData_GEIS'] + "\n" +
        "Pending Past Appointments : " + this.HomeReport['PendingPastAppointment_GEIS'] + "\n" +

        "Today Data in Default : " + this.HomeReport['TodaysDataInDefault_GEIS'] + "\n" +
        "Last 7 Days Data in Default : " + this.HomeReport['Last7DayDataInDefault_GEIS'] + "\n" +
        "Today Total Calls Pending : " + this.HomeReport['TodayPending_GEIS'] + this.HomeReport['TodayCalls_GEIS'] + "\n" +
        "Total Pending Processes : " + this.HomeReport['TodayPendingProcess_GEIS'] + "\n" +

        "Total Data in Default : " + this.HomeReport['DataInDefault_GEIS'] + "\n" +

        "Total Apt in Default : " + this.HomeReport['AptInDefault_GEIS'] + "\n" +
        "Total Enqs in Deafult : " + this.HomeReport['EnqInDefaultGEIS'] + "\n" +
        "Total Feedback in Default : " + this.HomeReport['FBInDefaultGEIS'] + "\n" +

        "Today Admissions : " + this.HomeReport['TotalAdmToday_GEIS'] + "\n" +
        "Last 7 Days New Admissions/Enqs : " + this.HomeReport['Last7DAdm_GEIS'] + "/" + this.HomeReport['Last7DEnq_GEIS'] + "\n" +
        "Last 30 Days New Admissions/Enqs : " + this.HomeReport['Last30DAdm_GEIS'] + "/" + this.HomeReport['Last30DEnq_GEIS'] + "\n" +
        "Last 90 Days New Admissions/Enqs : " + this.HomeReport['Last90DAdm_GEIS'] + "/" + this.HomeReport['Last90DEnq_GEIS'] + "\n" +
        "Total New Admissions/Enqs : " + this.HomeReport['TotalAdm_GEIS'] + "/" + this.HomeReport['TotalEnq_GEIS'] + "\n" +

        "Last 7 Days Enqs/Data : " + this.HomeReport['Last7SchEnq_GEIS'] + "/" + this.HomeReport['Last7DEnqData_GEIS'] + "\n" +
        "Last 30 Days Enqs/Data : " + this.HomeReport['Last30SchEnq_GEIS'] + "/" + this.HomeReport['Last30DEnqData_GEIS'] + "\n" +
        "Last 90 Days Enqs/Data : " + this.HomeReport['Last90SchEnq_GEIS'] + "/" + this.HomeReport['Last90DEnqData_GEIS'] + "\n" +
        "Total Enqs/Data : " + this.HomeReport['TotalSchEnq_GEIS'] + "/" + this.HomeReport['TotalEnqData_GEIS'] + "\n" +

        "Today Data Archived : " + this.HomeReport['ArchivedTodayGEIS'] + "\n" +
        "Last 7 Days Data Archived : " + this.HomeReport['Last7DaysDataArchivedGEIS'] + "\n" +

        "Last 7 Days Existing Admissions : " + this.HomeReport['Last7DExistingAdmData_GEIS'] + "/" + this.HomeReport['Last7DLastYearAdmData_GEIS'] + "\n" +
        "Last 30 Days New Admissions : " + this.HomeReport['Last30DExistingAdmData_GEIS'] + "/" + this.HomeReport['Last30DLastYearAdmData_GEIS'] + "\n" +
        "Last 90 Days New Admissions : " + this.HomeReport['Last90DExistingAdmData_GEIS'] + "/" + this.HomeReport['Last90DLastYearAdmData_GEIS'] + "\n" +
        "Total New Admissions : " + this.HomeReport['TotalExistingAdmData_GEIS'] + "/" + this.HomeReport['TotalLastYearAdmData_GEIS'];

      this.GEIS_ShareDatawhatsapp = GEIS;
      console.log("GEIS_ShareDatawhatsapp:", this.GEIS_ShareDatawhatsapp);

      var GEIS_SOD = "*" + currentdate + "* *| SOD*";
      GEIS_SOD += "\n*GEIS Progress Report by " + this.useName + "* \n___________________________\n\n" +

        "Today Enqs/Apmts : " + this.HomeReport['TotalProgressAppoints_GEIS'] + this.HomeReport['TotalTodaysAppoints_GEIS'] + "\n" +
        "Last 7 Days Enqs/Apmts : " + this.HomeReport['Last7DaysPostedAppoints_GEIS'] + this.HomeReport['Last7daysAppoints_GEIS'] + "\n" +
        "Today Data_Progress/Data_Added: " + this.HomeReport['TodyasDataAddedProgress_GEIS'] + this.HomeReport['TodyasDataAddedGEIS'] + "\n" +
        "Last 7 Days Data_Progress/Data_Added : " + this.HomeReport['Last7DaysDataAddedProgress_GEIS'] + this.HomeReport['Last7DaysDataAdded_GEIS'] + "\n" +

        "Total Pending PreData : " + this.HomeReport['PendingPreData_GEIS'] + "\n" +
        "Today Data/PreData : " + this.HomeReport['TodaysPreDtToData_GEIS'] + "/" + this.HomeReport['TodaysPreData_GEIS'] + "\n" +
        "Last 7 Days Data/PreData : " + this.HomeReport['Last7PreDtToData_GEIS'] + "/" + this.HomeReport['Last7PreData_GEIS'] + "\n" +
        "Pending Past Appointments : " + this.HomeReport['PendingPastAppointment_GEIS'] + "\n" +

        "Today Data in Default : " + this.HomeReport['TodaysDataInDefault_GEIS'] + "\n" +
        "Last 7 Days Data in Default : " + this.HomeReport['Last7DayDataInDefault_GEIS'] + "\n" +
        "Today Total Calls Pending : " + this.HomeReport['TodayPending_GEIS'] + this.HomeReport['TodayCalls_GEIS'] + "\n" +
        "Total Pending Processes : " + this.HomeReport['TodayPendingProcess_GEIS'] + "\n" +

        "Total Data in Default : " + this.HomeReport['DataInDefault_GEIS'] + "\n" +

        "Total Apt in Default : " + this.HomeReport['AptInDefault_GEIS'] + "\n" +
        "Total Enqs in Deafult : " + this.HomeReport['EnqInDefaultGEIS'] + "\n" +
        "Total Feedback in Default : " + this.HomeReport['FBInDefaultGEIS'] + "\n" +

        "Today Admissions : " + this.HomeReport['TotalAdmToday_GEIS'] + "\n" +

        "Last 7 Days New Admissions/Enqs : " + this.HomeReport['Last7DAdm_GEIS'] + "/" + this.HomeReport['Last7DEnq_GEIS'] + "\n" +
        "Last 30 Days New Admissions/Enqs : " + this.HomeReport['Last30DAdm_GEIS'] + "/" + this.HomeReport['Last30DEnq_GEIS'] + "\n" +
        "Last 90 Days New Admissions/Enqs : " + this.HomeReport['Last90DAdm_GEIS'] + "/" + this.HomeReport['Last90DEnq_GEIS'] + "\n" +
        "Total New Admissions/Enqs : " + this.HomeReport['TotalAdm_GEIS'] + "/" + this.HomeReport['TotalEnq_GEIS'] + "\n" +

        "Last 7 Days Enqs/Data : " + this.HomeReport['Last7SchEnq_GEIS'] + "/" + this.HomeReport['Last7DEnqData_GEIS'] + "\n" +
        "Last 30 Days Enqs/Data : " + this.HomeReport['Last30SchEnq_GEIS'] + "/" + this.HomeReport['Last30DEnqData_GEIS'] + "\n" +
        "Last 90 Days Enqs/Data : " + this.HomeReport['Last90SchEnq_GEIS'] + "/" + this.HomeReport['Last90DEnqData_GEIS'] + "\n" +
        "Total Enqs/Data : " + this.HomeReport['TotalSchEnq_GEIS'] + "/" + this.HomeReport['TotalEnqData_GEIS'] + "\n" +

        "Today Data Archived : " + this.HomeReport['ArchivedTodayGEIS'] + "\n" +
        "Last 7 Days Data Archived : " + this.HomeReport['Last7DaysDataArchivedGEIS'] + "\n" +

        "Last 7 Days Existing Admissions : " + this.HomeReport['Last7DExistingAdmData_GEIS'] + "/" + this.HomeReport['Last7DLastYearAdmData_GEIS'] + "\n" +
        "Last 30 Days New Admissions : " + this.HomeReport['Last30DExistingAdmData_GEIS'] + "/" + this.HomeReport['Last30DLastYearAdmData_GEIS'] + "\n" +
        "Last 90 Days New Admissions : " + this.HomeReport['Last90DExistingAdmData_GEIS'] + "/" + this.HomeReport['Last90DLastYearAdmData_GEIS'] + "\n" +
        "Total New Admissions : " + this.HomeReport['TotalExistingAdmData_GEIS'] + "/" + this.HomeReport['TotalLastYearAdmData_GEIS'];

      this.GEIS_ShareDatawhatsapp_SOD = GEIS_SOD;
      console.log("GEIS_ShareDatawhatsapp_SOD:", this.GEIS_ShareDatawhatsapp_SOD);

    })

  }


  get_progress_message_by_school(Type, School) {
    console.log("this.Date->", this.Date);
    var currentdate = this.datepipe.transform(this.Date, 'dd-MMM-yyyy hh:mm');
    console.log("currentdate->", currentdate);

    var message = "*" + currentdate + "* *| " + Type + "*";
    message += "\n*" + School + " Progress Report by " + this.useName + "* \n___________________________\n\n" +

      "Today Pending Calls : " + this.HomeReport['TodayPending_' + School] + this.HomeReport['TodayCalls_' + School] + "\n" +
      "Total Pending Processes : " + this.HomeReport['TodayPendingProcess_' + School] + "\n" +
      "Today Data in Default : " + this.HomeReport['TodaysDataInDefault_' + School] + "\n" +
      "Today Pending Process : " + this.HomeReport['TodayPendingProcess_' + School] + "\n" +
      "Today Apts in Default : " + this.HomeReport['TodayAptsInDefault_' + School] + "\n" +
      "Total Pending PreData : " + this.HomeReport['PendingPreData_' + School] + "\n" +
      "Total Data in Default : " + this.HomeReport['DataInDefault_' + School] + "\n" +
      "Total Past Apt is Default : " + this.HomeReport['TotalPastAptInDefault_' + School] + "\n" +
      "Pending Past Apts : " + this.HomeReport['PendingPastAppointment_' + School] + "\n" +
      "Last 7 Days Data in Default : " + this.HomeReport['Last7DayDataInDefault_' + School] + "\n" +
      "Total Apt in Default : " + this.HomeReport['AptInDefault_' + School] + "\n" +
      "Total Enqs in Deafult : " + this.HomeReport['EnqInDefault' + School] + "\n" +
      "Total Feedback in Default : " + this.HomeReport['FBInDefault' + School] + "\n";

    console.log("message data -> ", message);

    this.socialSharing.shareViaWhatsApp(message, "", "").then(() => {
      // Success!
      console.log("success");
    }).catch(() => {
      // Error!
      console.log("Error");
    });

  }

  GWE_WhatsAppShareBTN(type) {

    var msg = '';
    if (type == 'SOD') {
      msg = this.GWE_ShareDatawhatsapp_SOD;
    } else {
      msg = this.GWE_ShareDatawhatsapp;
    }
    console.log("shareBTN data -> ", msg);

    this.socialSharing.shareViaWhatsApp(msg, "", "").then(() => {
      // Success!
      console.log("success");
    }).catch(() => {
      // Error!
      console.log("Error");
    });

  }

  GWW_WhatsAppShareBTN(type) {

    var msg = '';
    if (type == 'SOD') {
      msg = this.GWW_ShareDatawhatsapp_SOD;
    } else {
      msg = this.GWW_ShareDatawhatsapp;
    }
    console.log("shareBTN data", msg);

    this.socialSharing.shareViaWhatsApp(msg, "", "").then(() => {
      // Success!
      console.log("success");
    }).catch(() => {
      // Error!
      console.log("Error");
    });

  }

  GEIS_WhatsAppShareBTN(type) {

    var msg = '';
    if (type == 'SOD') {
      msg = this.GEIS_ShareDatawhatsapp_SOD;
    } else {
      msg = this.GEIS_ShareDatawhatsapp;
    }
    console.log("shareBTN data", msg);
    this.socialSharing.shareViaWhatsApp(msg, "", "").then(() => {
      // Success!
      console.log("success");
    }).catch(() => {
      // Error!
      console.log("Error");
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DataProgressPage');
  }

  GotoprogressReport() {
    this.navCtrl.push(ProgressReportPage);
  }

  GotoMonthwiseReport() {
    this.navCtrl.push(MonthwiseProgressReportPage);
  }

  GotoAllprogressReport() {
    this.navCtrl.push(AllProgressReportPage);
  }

  GotoDefaultReport() {
    this.navCtrl.push(DefaultProgressPage);
  }

  GotoSTDWiseReport() {
    this.navCtrl.push(StdwiseStatusProgressPage);
  }

  //here
  GotoAllSTDProgresReport() {
    this.navCtrl.push(AllStdProgressReportPage);
  }

  GotoArchiveSTDWiseReport() {
    this.navCtrl.push(ArchiveStdWiseReportPage);
  }

  GotoArchiveSourceWiseReport() {
    this.navCtrl.push(ArchiveSourceWiseReportPage);
  }

  GotoArchiveUserWiseReport() {
    this.navCtrl.push(ArchiveUserWiseReportPage);
  }

  GotoArchiveDateWiseReport() {
    this.navCtrl.push(ArchiveDateWiseReportPage);
  }

  GotoDailyLogReportReport() {
    this.navCtrl.push(DailyLogReportPage);
  }

  MonthlyLogsReportPage() {
    this.navCtrl.push(MonthlyLogsReportPage);
  }

  GotoSTD_ReasonsReport() {
    this.navCtrl.push(ArchiveStdReasonsReportPage);
  }

  AllSchoolAdmisssionsReportPage() {
    this.navCtrl.push(AllSchoolAdmisssionsReportPage);
  }

  AllSchoolEnquiryReportPage() {
    this.navCtrl.push(AllSchoolEnquiryReportsPage);
  }

  TotalNoOeEnQReportAllSchoolPage() {
    this.navCtrl.push(TotalNoOeEnQReportAllSchoolPage);
  }

  PregressLogs() {
    this.navCtrl.push(DataProcessModuleLogsPage);
  }

  PreviousSchoolReport() {
    this.navCtrl.push(PreviousSchoolReportPage);
  }

  GotoMonthwiseWebsiteFormReport() {
    this.navCtrl.push(MonthwiseWebsiteEnqReportPage);
  }

  GotoMonthwiseJustdailReport() {
    this.navCtrl.push(MonthwiseJustdialEnqReportPage);
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues();

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  openFab(socialNet: string, fab: FabContainer) {
    fab.close();
    if (socialNet == "AddEnq") {
      this.open_enquiry_form(null);
    }
    if (socialNet == "JustDialData") {
      this.Gust_open_JustDial_form(socialNet);
    }
    if (socialNet == "callLog") {
      this.navCtrl.setRoot(NonenquirylogPage);
    }
    if (socialNet == "dailylog") {
      this.navCtrl.setRoot(DailyCallLogsPage);
    }
  }

  Gust_open_JustDial_form(item) {
    let Model = this.modalCtrl.create(AddJustdialDataPage);
    Model.onDidDismiss(data => {
      console.log(data);
      if (data == undefined) {
      } else {
        // this.Gust_loadvalues(this.SchoolData[this.School], this.FUserId);
        ;
      }


    });
    Model.present();
  }

  open_enquiry_form(item) {
    let Sibling = 0;
    let Jd = null;
    if (item) {
      Sibling = 1;
    }
    let EnquiryModel = this.modalCtrl.create(EnquiryFormPage, {Siblings: Sibling, SiblingsData: item});
    EnquiryModel.onDidDismiss(data => {
      console.log(data);

      // this.checkCallStatusIsNull();

    });
    EnquiryModel.present();
  }

  removeCharacter(originalString, removeString) {

    console.log("originalString ->", originalString);
    if (originalString != undefined) {
      let newString = originalString.replace(removeString, '');
      console.log("newString ->", newString);
      return newString;
    } else {
      console.log("newString ->", originalString);
      return originalString;
    }
  }

  get_Admission_report(School) {

    let Report = '';
    this.service.httpcall('app_web_service/get_overall_admissions_report_by_school?FSchoolId=' + School).subscribe(data => {
      Report = data['Report'];
      console.log('OverAllReportAdm', Report);

      this.socialSharing.shareViaWhatsApp(Report, "", "").then(() => {
        // Success!
        console.log("success");
      }).catch(() => {
        // Error!
        console.log("Error");
      });

    });
  }

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      this.shownGroup = null;
    } else {
      this.shownGroup = group;
    }
  };

  isGroupShown(group) {
    return this.shownGroup === group;
  };

}



// WEBPACK FOOTER //
// ./src/pages/data-progress/data-progress.ts